import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_BESTUREN: (
        pageSizeCount,
        pageNumber,
        search
    ) => ({
        url: `bestuur?pageSize=${pageSizeCount}&page=${pageNumber}&search=${search}`,
        method: "get",
    }),

    GET_BESTUUR: (communityId) => ({
        url: `/bestuur/show/${communityId}`,
        method: "get",
    }),

    GET_SCHOOLS: (
        communityId,
        pageSizeCount,
        pageNumber,
        searchValue
    ) => ({
        url: `/bestuur/scholen-list?iCommunityId=${communityId}&pagesize=${pageSizeCount}&page=${pageNumber}&search=${searchValue}`,
        method: "get",
    }),

    SAVE_BESTUUR: {
        url: "bestuur/save",
        method: "post",
    },

    UPDATE_BESTUUR: {
        url: "bestuur/update",
        method: "put",
    },

    SAVE_SCHOOL: {
        url: "bestuur/scholen/save",
        method: "post",
    },

    UPDATE_SCHOOL: {
        url: "bestuur/scholen/update",
        method: "put",
    },

    DELETE_BESTUUR: {
        url: "bestuur/delete",
        method: "delete",
    },

    SAVE_FREE_FIELDS: {
        url: "bestuur/save-free-fields",
        method: "post",
    },
    GET_SEARCH_BESTUREN: (searchValue) => ({
        url: `bestuur?search=${searchValue}`,
        method: "get",
    }),

    GET_COORDINATORS: (communityId) => ({
          url: `/instellingen/bestuur/coordinator-lists?iCommunityId=${communityId}`,
        method: "get",
    }),

    GET_REPORTERS: (communityId) => ({
        url: `instellingen/bestuur/admin-lists?iCommunityId=${communityId}`,
        method: "get",
    }),

    REPORTER_ADD_REMOVE: {
        url: "instellingen/bestuur/toggle-user",
        method: "post",
    },
};

export const useBesturen = (
    pageSizeCount,
    pageNumber,
    search
) =>
    useApiFetcherSWR(
        API_ENDPOINT.GET_BESTUREN(
            pageSizeCount,
            pageNumber,
            search
        )
    );

export const useBestuur = (communityId) => {
    return useApiFetcherSWR(
        communityId
            ? API_ENDPOINT.GET_BESTUUR(communityId)
            : null
    );
};

export const useSchools = (
    communityId,
    pageSizeCount,
    pageNumber,
    searchValue
) =>
    useApiFetcherSWR(
        communityId
            ? API_ENDPOINT.GET_SCHOOLS(
                communityId,
                pageSizeCount,
                pageNumber,
                searchValue
            )
            : null
    );

export const useSaveBestuur = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_BESTUUR);

export const useUpdateBestuur = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_BESTUUR);

export const useSaveSchool = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_SCHOOL);

export const useUpdateSchool = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_SCHOOL);

export const useDeleteBestuur = () =>
    useApiFetcherSWR(API_ENDPOINT.DELETE_BESTUUR);

export const useSaveFreeFields = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_FREE_FIELDS);

export const useSearchBesturen = (searchValue) =>
    useApiFetcherSWR(
        searchValue
            ? API_ENDPOINT.GET_SEARCH_BESTUREN(searchValue)
            : null
    );

export const useCoordinators = (communityId) =>
    useApiFetcherSWR(
        communityId
            ? API_ENDPOINT.GET_COORDINATORS(communityId)
            : null
    );

export const useReporters = (communityId) =>
    useApiFetcherSWR(
        communityId
            ? API_ENDPOINT.GET_REPORTERS(communityId)
            : null
    );

export const useReporterAddRemove = () =>
    useApiFetcherSWR(API_ENDPOINT.REPORTER_ADD_REMOVE);